import React, { useEffect, useRef } from 'react';
// Mock crypto data - in a real app, this would come from an API
const cryptoData = [{
  name: 'Bitcoin',
  symbol: 'BTC',
  price: 63458.21,
  change: 2.4
}, {
  name: 'Ethereum',
  symbol: 'ETH',
  price: 3045.67,
  change: -1.2
}, {
  name: 'Solana',
  symbol: 'SOL',
  price: 142.53,
  change: 5.7
}, {
  name: 'Cardano',
  symbol: 'ADA',
  price: 0.45,
  change: -0.8
}, {
  name: 'Binance Coin',
  symbol: 'BNB',
  price: 587.32,
  change: 1.5
}, {
  name: 'XRP',
  symbol: 'XRP',
  price: 0.57,
  change: 3.2
}, {
  name: 'Polkadot',
  symbol: 'DOT',
  price: 6.78,
  change: -2.1
}, {
  name: 'Dogecoin',
  symbol: 'DOGE',
  price: 0.15,
  change: 8.4
}, {
  name: 'Avalanche',
  symbol: 'AVAX',
  price: 34.21,
  change: 4.3
}, {
  name: 'Chainlink',
  symbol: 'LINK',
  price: 14.67,
  change: 2.9
}];
export const CryptoTicker = () => {
  const tickerRef = useRef<HTMLDivElement>(null);
  useEffect(() => {
    const tickerElement = tickerRef.current;
    if (!tickerElement) return;
    // Clone the first set of items and append to create seamless loop
    const firstSet = tickerElement.querySelectorAll('.ticker-item');
    firstSet.forEach(item => {
      const clone = item.cloneNode(true);
      tickerElement.appendChild(clone);
    });
    // Calculate the total width of one set of items
    const firstSetWidth = Array.from(firstSet).reduce((width, item) => width + (item as HTMLElement).offsetWidth, 0);
    // Set the animation duration based on content width (slower speed)
    const duration = firstSetWidth / 25; // Slower speed factor (was 50)
    tickerElement.style.animationDuration = `${duration}s`;
  }, []);
  const formatPrice = (price: number) => {
    return price < 1 ? price.toFixed(4) : price.toFixed(2);
  };
  return <div className="bg-white text-gray-800 py-1 overflow-hidden border-b border-gray-200" data-id="element-49">
      <div className="relative overflow-hidden" data-id="element-50">
        <div ref={tickerRef} className="whitespace-nowrap inline-flex items-center animate-ticker" style={{
        animationTimingFunction: 'linear',
        animationIterationCount: 'infinite'
      }} data-id="element-51">
          {cryptoData.map((crypto, index) => <div key={index} className="ticker-item flex items-center px-4" data-id="element-52">
              <span className="font-medium mr-2" data-id="element-53">{crypto.symbol}</span>
              <span className="mr-2" data-id="element-54">${formatPrice(crypto.price)}</span>
              <span className={`text-xs ${crypto.change >= 0 ? 'text-green-600' : 'text-red-600'}`} data-id="element-55">
                {crypto.change >= 0 ? '+' : ''}
                {crypto.change}%
              </span>
            </div>)}
        </div>
      </div>
    </div>;
};